import { useCallback } from 'react';
import * as Role from '../../../../../constants/role';
import { isDigitacaoHabilitada } from '../../../../../helpers/digitacaoAntecipada';
import { pickDigitacaoPayload } from '../utils/pickDigitacaoPayload';

/**
 * Decide PATCH digitacao vs PUT completo e delega às actions Redux.
 * Fecha/avança apenas após callback de sucesso da saga.
 */
export const useMtBtSave = ({
  nsirStatus,
  digitadorId,
  userId,
  userRole,
  nsirId,
  digitacaoAntecipada,
  digitarNsmp,
  updateNsmp,
  saveNsmp,
  onSuccess,
  onReatribuida,
}) => {
  const shouldUsePatch = useCallback(
    () =>
      isDigitacaoHabilitada({
        status: nsirStatus,
        digitadorId,
        userId,
        userRole,
        digitacaoAntecipada,
      })
      && userRole === Role.DIGITADOR,
    [nsirStatus, digitadorId, userId, userRole, digitacaoAntecipada],
  );

  const savePayload = useCallback(
    (data, { advanceNext } = {}) => {
      const afterSuccess = (ok, result, statusCode) => {
        if (statusCode === 409) {
          onReatribuida?.(result);
          return;
        }
        if (ok) {
          onSuccess?.(result, { advanceNext });
        }
      };

      if (data?.id && shouldUsePatch()) {
        digitarNsmp({
          ...pickDigitacaoPayload(data),
          nsirId,
          callback: afterSuccess,
        });
        return;
      }

      const payload = { ...data, nsirId };
      if (data?.id) {
        updateNsmp(payload, afterSuccess);
      } else if (data) {
        saveNsmp(payload, afterSuccess);
      }
    },
    [
      shouldUsePatch,
      digitarNsmp,
      updateNsmp,
      saveNsmp,
      nsirId,
      onSuccess,
      onReatribuida,
    ],
  );

  return { shouldUsePatch, savePayload };
};

export default useMtBtSave;
